import { render, staticRenderFns } from "./HospitalAnnouncementSettingEdit.vue?vue&type=template&id=dc5dcbf6&scoped=true"
import script from "./HospitalAnnouncementSettingEdit.vue?vue&type=script&lang=ts"
export * from "./HospitalAnnouncementSettingEdit.vue?vue&type=script&lang=ts"
import style0 from "./HospitalAnnouncementSettingEdit.vue?vue&type=style&index=0&id=dc5dcbf6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5dcbf6",
  null
  
)

export default component.exports